// packages/shared/hooks/useUpdateSharingSettings.js

import { useState } from 'react';
import updateSharingSettings from '../data/updateSharingSettings';
import { useNotify } from '../context/NotificationContext';

/**
 * Hook to update sharing settings for the current user.
 *
 * @param {string} token - JWT auth token
 * @returns {Object} - { updateSettings, updating, updateError, success }
 */
export default function useUpdateSharingSettings(token) {
  const [updating, setUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);
  const [success, setSuccess] = useState(false);
  const notify = useNotify();

  const updateSettings = async (newSettings) => {
    setUpdating(true);
    setUpdateError(null);
    setSuccess(false);

    try {
      await updateSharingSettings(token, newSettings);
      setSuccess(true);
      notify.show('Sharing settings saved');
    } catch (err) {
      console.error('Failed to update sharing settings:', err);
      notify.show('Failed to update sharing settings');
      setUpdateError(err);
    } finally {
      setUpdating(false);
    }
  };

  return { updateSettings, updating, updateError, success };
}
